import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * v5.8 Addition 10 — Set New Password (public route).
 * Reached via /reset-password?token=<one-time token>.
 */
export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) toast.error("Reset link is missing its token");
  }, [token]);

  const submit = async () => {
    if (pw.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { reset_token: token, new_password: pw });
      toast.success("Password updated — please sign in");
      nav("/login");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "var(--cw-primary-dark)" }}
      data-testid="reset-password-page">
      <div className="bg-white rounded-xl p-8 w-full max-w-md space-y-4">
        <h1 className="cw-h2">Set a new password</h1>
        <p className="text-xs text-[var(--cw-muted)]">
          Choose a new password (min 8 characters).
        </p>
        <input type="password" value={pw} onChange={(e) => setPw(e.target.value)}
          placeholder="New password"
          className="w-full h-10 px-3 rounded-md border bg-white text-sm"
          style={{ borderColor: "var(--cw-border)" }}
          data-testid="reset-pw-input" />
        <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
          placeholder="Confirm password"
          className="w-full h-10 px-3 rounded-md border bg-white text-sm"
          style={{ borderColor: "var(--cw-border)" }}
          data-testid="reset-pw-confirm" />
        <button className="cw-btn-primary w-full h-11"
          disabled={busy || !token}
          onClick={submit}
          data-testid="reset-submit-btn">
          {busy ? "Updating…" : "Update password"}
        </button>
      </div>
    </div>
  );
}
